import React, {
    useState,
    useEffect,
    useContext
}
from "react";

import { store }
from "../../context/store";

import { functions }
from "../../constants/common-functions";

import { colorFunctions }
from "../../constants/colors";

import { useHistory }
from "react-router-dom";

import Header
from "../../components/Header";

import LeftMenu
from "../../components/LeftMenu";

import {
    COLOR_FOCUS
}
from "../../constants/general-constants";

import UtilisationFooter
from "./components/UtilisationFooter";

import { nonStandardUtilisationUrls }
from "../../constants/client-specifics";

import MobileUtilisationSummaryOrganisation
from "./mobile/MobileUtilisationSummaryOrganisation";


export default function UtilisationSummaryOrganisation()
{

    //--------------------------------------------------------
    // Context
    //--------------------------------------------------------

    const globalState =
        useContext(store);

    const history =
        useHistory();

    const queryContext =
        globalState?.state?.queryContext;


    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [organisations, setOrganisations] =
        useState([]);

    const [visible, setVisible] =
        useState(false);


    //--------------------------------------------------------
    // Load client / redirect
    //--------------------------------------------------------

    useEffect(
        function()
        {

            if(
                nonStandardUtilisationUrls.includes(
                    window.location.hostname
                )
            )
            {
                history.push(
                    "/utilisationallnonstandard/-100"
                );
            }

            colorFunctions.getPrimaryColor();

            functions.getArrayFromAjax(
                "/resolutionsoftwareplatform/getclient",
                null,
                function(client)
                {
                    sessionStorage.setItem(
                        "colorPrimary",
                        client.colorPrimary
                    );

                    sessionStorage.setItem(
                        "colorSecondary",
                        client.colorSecondary
                    );

                    sessionStorage.setItem(
                        "colorGradient",
                        client.colorGradient
                    );
                }
            );

            const timer =
                setTimeout(
                    function()
                    {
                        setVisible(true);
                    },
                    120
                );

            return function()
            {
                clearTimeout(timer);
            };

        },
        []
    );


    //--------------------------------------------------------
    // Load utilisation
    //--------------------------------------------------------

    useEffect(
        function()
        {

            const filterBean =
            {
            };

            functions.postFilterBeanAjax(

                "/resolutionsoftwareplatform/dashboard/utilisation/organisation",

                functions.buildPostBodyFilterBeanQueryContext(
                    filterBean,
                    queryContext
                ),

                handleReturnObject
            );

        },
        [queryContext?.utilisationSurveyId]
    );


    //--------------------------------------------------------
    // Handle return
    //--------------------------------------------------------

    function handleReturnObject(obj)
    {

        if(
            obj.utilisationSummaryOrganisations
        )
        {
            setOrganisations(
                obj.utilisationSummaryOrganisations
            );
        }

    }


    //--------------------------------------------------------
    // Main page
    //--------------------------------------------------------

    const thisContainer =
    {
        display:
            "flex",

        position:
            "fixed",

        flexDirection:
            "column",

        width:
            "100%",

        height:
            "100vh",

        left:
            "0px",

        top:
            "0px"
    };


    //--------------------------------------------------------
    // Floating page title
    //--------------------------------------------------------

    const header =
    {
        display:
            "flex",

        position:
            "fixed",

        width:
            "700px",

        left:
            "calc(50% - 350px)",

        top:
            "0px",

        zIndex:
            30000,

        justifyContent:
            "center",

        alignItems:
            "center",

        height:
            "50px",

        color:
            "rgba(255,255,255,0.84)",

        background:
            "linear-gradient(180deg,#171b20 0%,#0c0f12 100%)",

        //----------------------------------------------------
        // Flat
        //----------------------------------------------------

        borderRadius:
            "0px",

        borderBottom:
            "2px solid #20afe8",

        boxShadow:
            "0 8px 20px rgba(0,0,0,0.20)"
    };


    const titleContainer =
    {
        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "center",

        fontSize:
            "16px",

        fontWeight:
            400,

        letterSpacing:
            "0.1px",

        color:
            "rgba(255,255,255,0.82)"
    };


    //--------------------------------------------------------
    // Main scrolling area
    //--------------------------------------------------------

    const tableContainer =
    {
        position:
            "fixed",

        left:
            "68px",

        right:
            "0px",

        top:
            "0px",

        bottom:
            "70px",

        overflowY:
            "auto",

        overflowX:
            "hidden",

        zIndex:
            2,

        padding:
            "0 20px 70px 20px",

        boxSizing:
            "border-box"
    };


    //--------------------------------------------------------
    // Intro
    //--------------------------------------------------------

    const introContainer =
    {
        marginTop:
            "105px",

        marginLeft:
            "20px",

        marginRight:
            "20px",

        marginBottom:
            "24px"
    };


    const introTitle =
    {
        color:
            "#252b31",

        fontSize:
            "24px",

        fontWeight:
            700,

        lineHeight:
            "30px"
    };


    const introText =
    {
        marginTop:
            "4px",

        color:
            "#626972",

        fontSize:
            "14px",

        lineHeight:
            "18px",

        maxWidth:
            "760px"
    };


    //--------------------------------------------------------
    // Metric header
    //--------------------------------------------------------

    const metricHeaderContainer =
    {
        display:
            "flex",

        width:
            "calc(100% - 40px)",

        marginLeft:
            "20px",

        marginRight:
            "20px",

        alignItems:
            "stretch",

        gap:
            "0px",

        position:
            "sticky",

        top:
            "82px",

        zIndex:
            200,

        background:
            "rgba(247,248,250,0.94)",

        backdropFilter:
            "blur(12px)",

        WebkitBackdropFilter:
            "blur(12px)",

        paddingTop:
            "12px",

        paddingBottom:
            "12px",

        boxSizing:
            "border-box"
    };


    const organisationHeaderSpacer =
    {
        width:
            "215px",

        flexShrink:
            0
    };


    //--------------------------------------------------------
    // Rows
    //--------------------------------------------------------

    const tableRow =
    {
        display:
            "flex",

        width:
            "calc(100% - 40px)",

        marginLeft:
            "20px",

        marginRight:
            "20px",

        marginTop:
            "14px",

        minHeight:
            "64px",

        //----------------------------------------------------
        // Flat white data band
        //----------------------------------------------------

        borderRadius:
            "0px",

        background:
            "rgba(255,255,255,0.94)",

        border:
            "1px solid rgba(7,28,49,0.09)",

        boxShadow:
            "0 2px 5px rgba(7,28,49,0.07), " +
            "0 8px 22px rgba(7,28,49,0.08)",

        overflow:
            "hidden",

        transition:
            "all 180ms ease"
    };


	const tableRowLabel =
	{
	    display:
	        "flex",

	    position:
	        "relative",

	    alignItems:
	        "center",

	    width:
	        "215px",

	    flexShrink:
	        0,

	    overflow:
	        "hidden",

	    background:
	        "linear-gradient(135deg, #164d76 0%, #0e3556 100%)",

	    borderRadius:
	        "0px",

	    color:
	        "#ffffff",

	    padding:
	        "0 20px",

	    boxSizing:
	        "border-box",

	    fontSize:
	        "15px",

	    fontWeight:
	        500,

	    borderRight:
	        "1px solid rgba(255,255,255,0.10)"
	};


    const tableRowContent =
    {
        display:
            "flex",

        flex:
            1,

        minWidth:
            0,

        borderRadius:
            "0px"
    };


    const tableColumn =
    {
        display:
            "flex",

        flex:
            1,

        minWidth:
            0,

        alignItems:
            "center",

        justifyContent:
            "center",

        fontSize:
            "17px",

        fontWeight:
            400,

        color:
            "#252b31",

        borderRight:
            "1px solid rgba(7,28,49,0.06)"
    };


    //--------------------------------------------------------
    // Organisation rows
    //--------------------------------------------------------

    const organisationDisplay =
        organisations.map(
            function(item, index)
            {

                return (

                    <div
                        key={
                            item.organisationId
                            ||
                            item.organisationName
                            ||
                            index
                        }
                        style={tableRow}
                    >

					<div style={tableRowLabel}>

					    {/* architectural watermark */}

					    <div
					        style={{
					            position: "absolute",
					            width: "110px",
					            height: "110px",
					            right: "-20px",
					            bottom: "-48px",

					            border:
					                "18px solid rgba(255,255,255,0.045)",

					            transform:
					                "rotate(45deg)",

					            pointerEvents:
					                "none"
					        }}
					    />

					    <div
					        style={{
					            position: "absolute",
					            width: "55px",
					            height: "55px",
					            right: "18px",
					            bottom: "-28px",

					            border:
					                "10px solid rgba(255,255,255,0.035)",

					            transform:
					                "rotate(45deg)",

					            pointerEvents:
					                "none"
					        }}
					    />

					    <span
					        style={{
					            position: "relative",
					            zIndex: 1
					        }}
					    >
					        {item.organisationName}
					    </span>

					</div>


                        <div style={tableRowContent}>

                            <div style={tableColumn}>

                                {
                                    functions.formatNumber(
                                        item.focus,
                                        0
                                    )
                                }

                            </div>


                            <div style={tableColumn}>

                                {
                                    functions.formatNumber(
                                        item.utilised,
                                        1
                                    )
                                }%

                            </div>


                            <div style={tableColumn}>

                                {
                                    functions.formatNumber(
                                        item.desksOccupied,
                                        1
                                    )
                                }%

                            </div>


                            <div style={tableColumn}>

                                {
                                    functions.formatNumber(
                                        item.peakMoment,
                                        1
                                    )
                                }%

                            </div>


                            <div style={tableColumn}>

                                {
                                    functions.formatNumber(
                                        item.morning,
                                        1
                                    )
                                }%

                            </div>


                            <div style={tableColumn}>

                                {
                                    functions.formatNumber(
                                        item.afternoon,
                                        1
                                    )
                                }%

                            </div>


                            <div style={tableColumn}>

                                {
                                    functions.formatNumber(
                                        item.nonCore,
                                        1
                                    )
                                }%

                            </div>


                            <div style={tableColumn}>

                                {
                                    functions.formatNumber(
                                        item.week1,
                                        1
                                    )
                                }%

                            </div>


                            <div
                                style={{
                                    ...tableColumn,

                                    borderRight:
                                        "none"
                                }}
                            >

                                {
                                    functions.formatNumber(
                                        item.week2,
                                        1
                                    )
                                }%

                            </div>

                        </div>

                    </div>

                );

            }
        );


    //--------------------------------------------------------
    // Intro fade
    //--------------------------------------------------------

    const overlayStyle =
    {
        position:
            "fixed",

        top:
            0,

        left:
            0,

        width:
            "100%",

        height:
            "100%",

        background:
            "rgba(255,255,255,0.85)",

        pointerEvents:
            "none",

        opacity:
            visible
                ? 0
                : 1,

        zIndex:
            0,

        transition:
            "opacity 900ms ease"
    };


    //--------------------------------------------------------
    // Mobile
    //--------------------------------------------------------

    if(
        window.innerWidth <= 768
    )
    {

        return (

            <MobileUtilisationSummaryOrganisation />

        );

    }


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <div style={thisContainer}>

            <Header
                showSurveySelector={true}
            />

            <LeftMenu />


            <div style={overlayStyle} />


            {/* ------------------------------------------------
                Top title
                ------------------------------------------------ */}

            <div style={header}>

                <div style={titleContainer}>

                    Utilisation: Departmental Summary

                </div>

            </div>


            {/* ------------------------------------------------
                Main content
                ------------------------------------------------ */}

            <div style={tableContainer}>

                <div style={introContainer}>

                    <div style={introTitle}>

                        Departmental Summary

                    </div>

                    <div style={introText}>

                        Utilisation performance by department,
                        comparing workstation demand,
                        occupancy patterns, peak periods
                        and weekly utilisation.

                    </div>

                </div>


                {/* ------------------------------------------------
                    Column headers
                    ------------------------------------------------ */}

                <div style={metricHeaderContainer}>

                    <div
                        style={organisationHeaderSpacer}
                    />


					<MetricHeader
					    title="FWS"
					    colour="#25d0cb"
					    colourDark="#12aaa8"
					/>

					<MetricHeader
					    title="Utilised %"
					    colour="#6995ef"
					    colourDark="#4776d5"
					/>

					<MetricHeader
					    title="Desks Occupied"
					    colour="#38b51a"
					    colourDark="#168e08"
					/>

					<MetricHeader
					    title="Peak %"
					    colour="#f03770"
					    colourDark="#d90d4c"
					/>

					<MetricHeader
					    title="Morning"
					    colour="#ffb629"
					    colourDark="#e99300"
					/>

					<MetricHeader
					    title="Afternoon"
					    colour="#a56af4"
					    colourDark="#7540d6"
					/>

					<MetricHeader
					    title="Non-Core"
					    colour="#7b8490"
					    colourDark="#555e69"
					/>

					<MetricHeader
					    title="Week 1"
					    colour="#32b7e9"
					    colourDark="#0795cf"
					/>

					<MetricHeader
					    title="Week 2"
					    colour="#29c4b5"
					    colourDark="#0c9d91"
					/>

                </div>


                {/* ------------------------------------------------
                    Organisation data
                    ------------------------------------------------ */}

                {organisationDisplay}


                <div
                    style={{
                        minHeight:
                            "120px"
                    }}
                />

            </div>


            <UtilisationFooter />

        </div>

    );

}


//============================================================
// METRIC HEADER
//============================================================

function MetricHeader(
{
    title,
    colour,
    colourDark
})
{
    return (

        <div
            style={{
                flex: 1,
                minWidth: 0,
                height: "58px",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",

                textAlign: "center",

                padding: "0 7px",
                boxSizing: "border-box",

                borderRadius: "0px",

                background:
                    `linear-gradient(
                        180deg,
                        ${colour} 0%,
                        ${colourDark} 100%
                    )`,

                color: "#ffffff",

                fontSize: "12px",
                lineHeight: "15px",
                fontWeight: 600,

                borderRight:
                    "1px solid rgba(255,255,255,0.18)",

                boxShadow:
                    "0 5px 14px rgba(7,28,49,0.15)",

                textShadow:
                    "0 1px 2px rgba(0,0,0,0.12)"
            }}
        >

            {title}

        </div>

    );
}